import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;


@Component({
  selector: 'app-city-bd-tracker',
  templateUrl: './city-bd-tracker.component.html',
  styleUrls: ['./city-bd-tracker.component.css']
})
export class CityBdTrackerComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  perpage: number = 25; usersList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circle = '';
  search: string; currentUserId: any; circles_copy = []; status = ''; UserId: any = ''
  booleanValue: any = false; start_date: string = ''; end_date: string = '';
  constructor(private userapi: UserService, private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.sharedapi.getRole()
      .subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');

    this.activatedRoute.params.subscribe(params => {
      if (params['user_id']) {
        this.UserId = params['user_id'];
      }

    });
  }
  ngAfterViewInit() {
    this.loadCityBdHistory(0, this.perpage);
  }

  async loadCityBdHistory(pageIndex, perpage) {
    this.usersList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    this.userapi.loadCityBdHistory(this.UserId, this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      if (data.status) {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if (data.status) {
          this.usersList = data.data;
        } else {
          this.usersList = [];
        }
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }




  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadCityBdHistory(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadCityBdHistory(event.pageIndex, event.pageSize);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
      //this.loadleads(0,this.perpage);
    }
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
    //this.loadleads(0,this.perpage);
  }



}
